export default "__VITE_ASSET__7ef33101__"